import React from 'react';
import './style/MainSizer.css';
import HundredPercentContainer from './HundredPercentContainer';
import ModalTarget, { APP_ID } from './ModalTarget';
import { VSTUI_DIALOG_TARGET } from '../vstui/VstuiDialog';
import { ToastContainer } from 'app/ui/core/common/Toast';

export default class MainSizer extends React.Component {
  render() {
    const { children, ...sizeInfo } = this.props;

    const { overflow, overflowX, overflowY, ...restProps } = sizeInfo;

    const overflowProps = { overflow, overflowX, overflowY };
    Object.keys(overflowProps).forEach(
      k => !overflowProps[k] && delete overflowProps[k]
    );

    const innerProps = {
      ...restProps,
    };

    if (restProps.minWidth) {
      innerProps.overflowX = 'hidden';
    }
    if (restProps.minHeight) {
      innerProps.overflowXY = 'hidden';
    }

    return (
      <div className="MainSizer" style={overflowProps} id={VSTUI_DIALOG_TARGET}>
        <div style={{ ...innerProps }}>
          <HundredPercentContainer id={APP_ID}>
            {children}
          </HundredPercentContainer>
          <ModalTarget />
          <ToastContainer />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/ui/core/common/MainSizer.js